import store from "../../store/store.jsx";

const initialState = {
  progress: 0,
  currentLang: "TC",
  currentScene: "Scene1",
  currentQuestion: null,
  leftEnabled: true,
  rightEnabled: true,
  currentScore: 0
};

export default function sceneReducer(state = initialState, action) {
  switch (action.type) {
    case "@@CHANGE_SCENE_PROGRESS":
      return {
        ...state,
        progress: action.payload
      };

    case "@@SELECT_LANGUAGE":
      return {
        ...state,
        currentLang: action.payload
      };

    case "@@CHANGE_SCENE":
      return {
        ...state,
        currentScene: action.payload
      };

    case "@@UPDATE_CURRENT_QUESTION":
      return {
        ...state,
        currentQuestion: action.payload
      };

    case "@@DISABLE_LEFT_CLICK":
      return {
        ...state,
        leftEnabled: false
      };

    case "@@ENABLE_LEFT_CLICK":
      return {
        ...state,
        leftEnabled: true
      };

    case "@@DISABLE_RIGHT_CLICK":
      return {
        ...state,
        rightEnabled: false
      };

    case "@@ENABLE_RIGHT_CLICK":
      return {
        ...state,
        rightEnabled: true
      };

    case "@@UPDATE_SCORE":
      return {
        ...state,
        currentScore: action.payload
      };

    default:
      return state;
  }
}

export function dispatchChangeScene(string) {
  store.dispatch({
    type: "@@CHANGE_SCENE",
    payload: string
  });
}

export function dispatchChangeLang(string) {
  store.dispatch({
    type: "@@SELECT_LANGUAGE",
    payload: string
  });
}

export function dispatchChangeProgress(number) {
  store.dispatch({
    type: "@@CHANGE_SCENE_PROGRESS",
    payload: number
  });
}

export function dispatchUpdateCurrentQuestion(object) {
  store.dispatch({
    type: "@@UPDATE_CURRENT_QUESTION",
    payload: object
  });
}

export function dispatchDisableLeftClick() {
  store.dispatch({
    type: "@@DISABLE_LEFT_CLICK"
  });
}

export function dispatchEnableLeftClick() {
  store.dispatch({
    type: "@@ENABLE_LEFT_CLICK"
  });
}

export function dispatchDisableRightClick() {
  store.dispatch({
    type: "@@DISABLE_RIGHT_CLICK"
  });
}

export function dispatchEnableRightClick() {
  store.dispatch({
    type: "@@ENABLE_RIGHT_CLICK"
  });
}

export function dispatchUpdateScore(number) {
  store.dispatch({
    type: "@@UPDATE_SCORE",
    payload: number
  });
}
